"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var LftProgressBar_styles_1 = require("./LftProgressBar.styles");
var LftProgressBar = function (_a) {
    var bgColor = _a.bgColor, id = _a.id, value = _a.value, _b = _a.size, size = _b === void 0 ? "sm" : _b;
    return ((0, jsx_runtime_1.jsx)(LftProgressBar_styles_1.ProgressBarStyled, { "aria-valuemax": 100, "aria-valuemin": 0, bgColor: bgColor, "data-lift": "lft-progressbar", id: id, max: 100, value: value, size: size }, void 0));
};
exports.default = LftProgressBar;
